import ScenarioTemplate from './ScenarioTemplate';
import DefaultTemplate from './DefaultTemplate';

const templateMap = {
  facetPlanClientView: { template: ScenarioTemplate },
};

export default function getTemplate(collection) {
  if (collection) {
    const template = templateMap[collection.meta().type()];

    if (template) {
      return template;
    }
  }
  return { template: DefaultTemplate };
}
